import styled from "styled-components";
import {LiveCasinoGridItemDrawDefaultBox} from "./live-casino-grid-item-draw.default.box";
import {RED} from '../../../css-constants';

export const LiveCasinoGridItemDrawMrGreenBox = styled(LiveCasinoGridItemDrawDefaultBox)`
    color: ${({theme, drawColor}) => {
        if (drawColor) {
            return drawColor === RED
                ? theme.components.newLiveCasino.colors.gridItem.drawRedItemBackground
                : theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground;
        }
        return theme.colors.textContrast;
    }};

    &:first-child {
        color: ${({theme, drawColor}) => {
            return drawColor ? theme.colors.textContrast : theme.colors.backgroundDark;
        }};

        background: ${({theme, drawColor}) => {
            if (drawColor) {
                return drawColor === RED
                    ? theme.components.newLiveCasino.colors.gridItem.drawRedItemFirstChildBackground
                    : theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground;
            }

            return theme.colors.textContrast;
        }};
    }
`;
